import Cookies from 'js-cookie'

export default {

    set(name,value){
        return Cookies.set(name,value);
    },

    get(name){
        return Cookies.get(name);
    },

    delete(name){
        return Cookies.remove(name);
    },

    all(){
        return Cookies.get();
    }
}